import type { OrganizationImportPreview, OrganizationImportResult } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

/** 組織メンバー一覧（ユーザーの氏名・メールアドレス付き） */
export interface OrganizationMemberWithUser {
  id: string
  userId: string
  name: string
  email: string
  employeeNumber: string | null
  departmentName: string | null
  positionName: string | null
  parentId: string | null
}

export function useOrganizationMembers() {
  return useQuery<OrganizationMemberWithUser[]>({
    queryKey: ['organizations'],
    queryFn: () => api.get('/api/organizations'),
  })
}

export function useImportOrganization() {
  const qc = useQueryClient()
  return useMutation<OrganizationImportResult, Error, string>({
    mutationFn: (csvText: string) => api.postRaw('/api/organizations/import', csvText),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['organizations'] }),
  })
}

export function usePreviewImport() {
  return useMutation<OrganizationImportPreview, Error, string>({
    mutationFn: (csvText: string) => api.postRaw('/api/organizations/import/preview', csvText),
  })
}
